<script>
    import { LottiePlayer } from '@lottiefiles/svelte-lottie-player';
    import { onMount } from 'svelte';

    let player = $state();

    onMount(() => {
        player.getLottie().addEventListener("data_ready", () => { // HACK to work around issue whwne direction=-1 and loop=false https://github.com/airbnb/lottie-web/issues/118#issuecomment-239319708
            player.seek(player.getLottie().totalFrames);
        });
    });
</script>

<!--https://lottiefiles.com/user/69888-->
<!-- <LottiePlayer src="https://assets2.lottiefiles.com/packages/lf20_VDNxBo.json" background="transparent" renderer="svg" speed={1} direction={-1} width={300} height={300} autoplay={true} loop={false} controls={false} controlsLayout={[]} /> -->
<div class="spinner">
    <LottiePlayer bind:this={player}
    src='https://assets2.lottiefiles.com/packages/lf20_VDNxBo.json'
    autoplay={true}
    loop={false}
    controls={false}
    renderer='svg'
    background='transparent'
    height={300}
    width={300}
    direction={-1}
    controlsLayout={[]} />
</div>

<!--alternative -->
<!--https://lottiefiles.com/mervinin-->
<!-- <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_a5nWM9.json" background="#e3342f" speed="1" style="width: 300px; height: 300px;" autoplay></lottie-player> -->

<!--alternative -->
<!--https://lottiefiles.com/sanil297-->
<!-- <lottie-player src="https://assets5.lottiefiles.com/packages/lf20_xhyszish.json" background="transparent" speed="1" style="width: 300px; height: 300px;" autoplay></lottie-player> -->


<!--alternative, has exact match for unlock-->
<!--https://lottiefiles.com/user38902-->
<!-- <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_5ecsjzta.json"  background="transparent"  speed="1"  style="width: 300px; height: 300px;"  loop controls autoplay></lottie-player> -->